export default __webpack_public_path__ + "static/media/IMG_2350.929407dd.jpg";